module.exports = __webpack_public_path__ + "assets/line-567f57.gif";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/line.gif
// module id = 821
// module chunks = 2